module.exports = __webpack_public_path__ + "media/luxury-2026/black-dining-7b09f7de.jpg";